import type { RouteLocationRaw } from 'vue-router';

export const billableTypes = [
  { name: 'Student', value: 'Student' },
  { name: 'Classroom', value: ' Classroom' },
  { name: 'Classroom Section', value: ' ClassroomSection' },
];

export const classroomTypeDefaults = {
  'primary': [
    { name: 'Nursery 1', abbreviation: 'Nur1', sequence: 1 },
    { name: 'Nursery 2', abbreviation: 'Nur2', sequence: 2 },
    { name: 'Nursery 3', abbreviation: 'Nur3', sequence: 3 },
    { name: 'Primary 1', abbreviation: 'Pry1', sequence: 4 },
    { name: 'Primary 2', abbreviation: 'Pry2', sequence: 5 },
    { name: 'Primary 3', abbreviation: 'Pry3', sequence: 6 },
    { name: 'Primary 4', abbreviation: 'Pry4', sequence: 7 },
    { name: 'Primary 5', abbreviation: 'Pry5', sequence: 8 },
  ],
  'secondary': [
    { name: 'Junior Secondary School 1', abbreviation: 'JSS1', sequence: 1 },
    { name: 'Junior Secondary School 2', abbreviation: 'JSS2', sequence: 2 },
    { name: 'Junior Secondary School 3', abbreviation: 'JSS3', sequence: 3 },
    { name: 'Senior Secondary School 1', abbreviation: 'SSS1', sequence: 4 },
    { name: 'Senior Secondary School 2', abbreviation: 'SSS2', sequence: 5 },
    { name: 'Senior Secondary School 3', abbreviation: 'SSS3', sequence: 6 },
  ],
  'tertiary': [
    { name: '100', abbreviation: '100L', sequence: 1 },
    { name: '200', abbreviation: '200L', sequence: 2 },
    { name: '300', abbreviation: '300L', sequence: 3 },
    { name: '400', abbreviation: '400L', sequence: 4 },
    { name: '500', abbreviation: '500L', sequence: 5 },
  ],
};

export const schoolLabels = {
  primary: {
    TEACHER: 'Staff',
    STUDENT: 'Student',
    CLASS: 'Class',
    CLASSROOM: 'Classroom',
    CLASSROOM_SECTION: 'Classroom Section',
    TERM: 'Term',
    SESSION: 'Session',
    SUBJECT: 'Subject',
  },
  secondary: {
    TEACHER: 'Staff',
    STUDENT: 'Student',
    CLASS: 'Class',
    CLASSROOM: 'Classroom',
    CLASSROOM_SECTION: 'Classroom Section',
    TERM: 'Term',
    SESSION: 'Session',
    SUBJECT: 'Subject',
  },
  tertiary: {
    TEACHER: 'Staff',
    STUDENT: 'Student',
    CLASS: 'Level',
    CLASSROOM: 'Level',
    CLASSROOM_SECTION: 'Level',
    TERM: 'Semester',
    SESSION: 'Session',
    SUBJECT: 'Course',
  },
};

export interface LandingNavItem {
  /** Stable key; also builds the data-testids: `navbar-<key>-link` / `navbar-mobile-<key>-link`. */
  key: string;
  label: string;
  to: RouteLocationRaw;
  /** Apply active-route highlighting. False for in-page hash anchors (e.g. "How it Works"). */
  active: boolean;
}

/** Primary navigation shown in the landing page navbar (desktop + mobile). */
export const landingNavItems: readonly LandingNavItem[] = [
  { key: 'home', label: 'Home', to: { name: 'landing' }, active: true },
  { key: 'features', label: 'Features', to: { name: 'landing-features' }, active: true },
  { key: 'roles', label: 'For Your Role', to: { name: 'landing-for-your-role' }, active: true },
  { key: 'pricing', label: 'Pricing', to: { name: 'landing-pricing' }, active: true },
  { key: 'how', label: 'How it Works', to: { name: 'landing', hash: '#how' }, active: false },
];

/** Classes applied to the currently-active landing nav link. */
export const landingNavActiveClass = 'text-[#1A56DB] font-semibold';
